// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.bold[data-v-a563d662] {\n  font-weight: 700;\n}\n", ""]);
// Exports
module.exports = exports;
